export default "../css/4eb4d2fd6eec3d6e7ea6e235d691b0be.otf";